export function pickCurrencySymbolFromString(currencyLabel){
    return currencyLabel?.split('(')?.[1]?.split(')')?.[0]
}